import Immutable from 'immutable';
import {
  FLAG_GETTING_ITINERARY_SEARCH_OMISSIONS,
  GET_ITINERARY_SEARCH_OMISSIONS,
  CLEAR_ITINERARY_SEARCH_OMISSIONS,
  FLAG_ITINERARY_SEARCH_OMISSION_ACTIVITY,
  CLEAR_ITINERARY_SEARCH_OMISSION,
  GET_ITINERARY_SEARCH_OMISSION,
} from '../../../actions/types/itinerary';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_GETTING_ITINERARY_SEARCH_OMISSIONS:
      return state.setIn(['all', 'loading'], action.payload);
    case GET_ITINERARY_SEARCH_OMISSIONS:
      return state.setIn(['all', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_SEARCH_OMISSIONS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ITINERARY_SEARCH_OMISSION_ACTIVITY:
      if (action.payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(action.payload),
        );
      }
      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ITINERARY_SEARCH_OMISSION:
      return state.setIn(['current', 'content'], Immutable.Map(action.payload));
    case CLEAR_ITINERARY_SEARCH_OMISSION:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
